import React, { forwardRef } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/links';
type CTAButtonProps = {
  label: string;
  sublabel?: string;
  className?: string;
  shake?: boolean;
};
export const CTAButton = forwardRef<HTMLAnchorElement, CTAButtonProps>(function CTAButton({
  label,
  sublabel,
  className = '',
  shake = false
}, ref) {
  return <a ref={ref} href={CHECKOUT_URL} className={`group mx-auto flex w-full max-w-xl flex-col items-center justify-center rounded-2xl bg-cta px-4 py-4 text-center text-white shadow-[0_6px_0_0_#14532D] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-1 active:shadow-[0_2px_0_0_#14532D] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold md:py-5 ${shake ? 'animate-cta-shake' : ''} ${className}`} data-id="element-29" data-mp="2tz34c8lkage5">
      <span className="flex items-center gap-2 whitespace-nowrap text-[17px] font-extrabold uppercase leading-tight tracking-tight sm:text-lg md:text-xl" data-id="element-30" data-mp="38osg0xra62so">
        {label}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="19b963winkame" />
      </span>
      {sublabel && <span className="mt-1 text-xs font-semibold text-white/90 md:text-sm" data-id="element-32" data-mp="1ibxnn1798t41">{sublabel}</span>}
    </a>;
});